/**
 * Shared constants for health profile data across the application
 * Used by pharmacy customer creation and prescription ingestion workflows
 */

/**
 * Common allergies for customer health profile
 */
export const COMMON_ALLERGIES = [
    { id: "5662329769702d0523000000", name: "Penicillins" },
    { id: "523cbe11ad393f143f000270", name: "Codeine" },
    { id: "523cbe12ad393f143f000615", name: "Amoxicillin" },
    { id: "525c149dad393fca1d000018", name: "Iodine" },
    { id: "528e60323ffd28ba3d000001", name: "Bactrim" },
    { id: "52af751b3ffd28edb2000018", name: "Latex" },
    { id: "523cbe12ad393f143f0006a9", name: "Paroxetine" },
    { id: "523cbe13ad393f143f000bd5", name: "Paxil" },
    { id: "523cbe13ad393f143f000d67", name: "Prilosec" },
    { id: "55b258b869702d6042050000", name: "Xarelto" },
    { id: "5e3dbcc3bf1c604005f4711a", name: "Sulfa/sulfonamides" },
    { id: "523cbe1aad393f143f002a27", name: "None" },
] as const;

/**
 * Common health conditions for customer health profile
 */
export const COMMON_HEALTH_CONDITIONS = [
    { id: "53504d460937fe33aa001366", name: "High Cholesterol" },
    { id: "5539ab3a69702d7468090000", name: "Anxiety Disorder" },
    { id: "560f3dfe69702d3654090000", name: "Gastroesophageal Reflux Disease (gerd)" },
    { id: "560f3dfe69702d36540b0000", name: "Migraine" },
    { id: "53504d450937fe33aa001222", name: "Type 1 Diabetes" },
    { id: "53504d450937fe33aa00121c", name: "Type 2 Diabetes" },
    { id: "5539ab3a69702d74680b0000", name: "Heart Failure" },
    { id: "5615d58469702d7efb0c0000", name: "Chronic Obstructive Pulmonary Disease (copd)" },
    { id: "548b2cc269702d1e63320000", name: "None" },
] as const;
